var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"p-3 article",staticStyle:{"text-align":"center"}},[_c('p',[_vm._v(_vm._s(_vm.message))]),(_vm.actionLabel)?_c('b-button',{staticClass:"mt-2",attrs:{"type":"is-primary","size":"is-small"},on:{"click":function($event){return _vm.$emit('action')}}},[_vm._v(" "+_vm._s(_vm.actionLabel)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }